<div class="header" [ngClass]="{ 'sticky': isScrolled, 'shadow': isOffsetTop }">
  <div class="header__content">
    <div class="container">
      <div class="wrapper">
        <div class="header__block">
          <div class="header__nav">
            <div class="header__back">
              <p-button icon="pi pi-angle-left" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded" (onClick)="goToDashboard()"></p-button>
            </div>

            <div class="header__logo">
              <app-logo-krediya color="color"></app-logo-krediya>
            </div>
          </div>

          <div class="header__contact">
            <div class="header__contactCont">
              <a [href]="'https://wa.me/' + phoneNumberService" target="_blank">
                <span>Ayuda</span>
                <i>
                  <app-whatsapp-icon color="blue"></app-whatsapp-icon>
                </i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
